module.exports = __webpack_public_path__ + "media/images/icons/battery-empty-c092bc005c01f15aaeb866e661c14603.svg";